import { FormTextField } from '@shared/components';

import { BaseItemSetInformationSection } from '../../components';

export default function ItemSetCreationInformationSection() {
  return (
    <BaseItemSetInformationSection>
      <FormTextField label='Item Set Name' placeholder='กรอกชื่อ Item Set' name='details.name' />
    </BaseItemSetInformationSection>
  );
}
